import { Clear, ExpandMore, Menu } from "@mui/icons-material"
import { Accordion, AccordionSummary, Box, Drawer, IconButton, Typography } from "@mui/material"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import Scrollbar from "@sap/components/scrollbar"

import navbarNavigations from "../config"
import type { NavbarChildNavigationType, NavbarNavigationType } from "../config"
import { NavLink } from "./NavLink"

type navigationTypes = NavbarNavigationType[] | NavbarChildNavigationType[]

const MobileMenu = () => {
  const { t } = useTranslation("common", { keyPrefix: "navbar" })
  const [openDrawer, setOpenDrawer] = useState(false)

  const renderLevels = (data: navigationTypes) => {
    return data.map((item, index) => {
      if ("child" in item && item.child) {
        return (
          <Accordion
            square
            key={index}
            elevation={0}
            disableGutters
            sx={{
              boxShadow: "none !important",
              "&:not(:last-child)": {
                borderBottom: 0,
              },
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              sx={{
                padding: 0,
                minHeight: 48,
                "& .Mui-expanded": {
                  color: "primary.main",
                  margin: 0,
                },
                "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                  margin: 0,
                  "& .MuiSvgIcon-root": {
                    color: "primary.main",
                  },
                },
              }}
            >
              <Typography>{t(item.title)}</Typography>
            </AccordionSummary>
            <Box
              sx={{
                mx: 2,
              }}
            >
              {renderLevels(item.child)}
            </Box>
          </Accordion>
        )
      }
      if (item.url) {
        return (
          <Typography
            key={index}
            sx={{
              py: 1,
            }}
          >
            <NavLink
              to={item.url}
              onClick={() => {
                setOpenDrawer(false)
              }}
            >
              {t(item.title)}
            </NavLink>
          </Typography>
        )
      }
    })
  }
  return (
    <>
      <IconButton
        onClick={() => setOpenDrawer(true)}
        sx={{
          flexShrink: 0,
          color: "grey.600",
        }}
      >
        <Menu />
      </IconButton>
      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        sx={{
          zIndex: 15001,
        }}
      >
        <Box
          sx={{
            width: "100dvw",
            height: "100%",
            position: "relative",
          }}
        >
          <Scrollbar
            sx={{
              height: "100dvh",
            }}
          >
            <Box
              sx={{
                maxWidth: 500,
                margin: "auto",
                position: "relative",
                height: "100%",
                px: 5,
                py: 8,
              }}
            >
              <IconButton
                onClick={() => setOpenDrawer(false)}
                sx={{
                  position: "absolute",
                  right: 30,
                  top: 15,
                }}
              >
                <Clear fontSize="small" />
              </IconButton>

              {renderLevels(navbarNavigations)}
            </Box>
          </Scrollbar>
        </Box>
      </Drawer>
    </>
  )
}
export default MobileMenu
